module.exports = __webpack_public_path__ + "static/cathy_logo_new-bd1ca2c2faeb5a9e382f1fe728930201.png";